import { render, staticRenderFns } from "./FieldAttachment.vue?vue&type=template&id=18814a31&"
import script from "./FieldAttachment.vue?vue&type=script&lang=ts&"
export * from "./FieldAttachment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18814a31')) {
      api.createRecord('18814a31', component.options)
    } else {
      api.reload('18814a31', component.options)
    }
    module.hot.accept("./FieldAttachment.vue?vue&type=template&id=18814a31&", function () {
      api.rerender('18814a31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StockAdjustment/FieldAttachment.vue"
export default component.exports